import React, { useContext } from 'react';

import { LessonComponentBase } from './LessonComponent';
import { LessonType } from './LessonVm';
import TemplateModel from './TemplateModel';

interface LessonEditContextModel {
  lessonType: LessonType;
  /** Component keys */
  selectedComponentKeys: number[];
  templateData: TemplateModel[];
  handleSettingsChange: (component: LessonComponentBase) => void;
}

const LessonEditContext = React.createContext<LessonEditContextModel>({
  lessonType: null,
  selectedComponentKeys: [],
  templateData: null,
  handleSettingsChange: () => {}
});

export const useLessonEditContext = () => useContext(LessonEditContext);

export const LessonEditContextProvider = LessonEditContext.Provider;
export const LessonEditContextConsumer = LessonEditContext.Consumer;
export default LessonEditContext;
